export const Role = {
  administrator: 'ADMINISTRATOR',
  terminalUser: 'TERMINAL_USER',
  operations: 'OPERATIONS',
  humanResources: 'HUMAN_RESOURCES',
  accountManager: 'ACCOUNT_MANAGER',
  marketing: 'MARKETING',
  support: 'SUPPORT',
  finance: 'FINANCE',
  eventAccountUser: 'EVENT_ACCOUNT_USER',
  eventManager: 'EVENT_MANAGER',
  eventCleaningEmployee: 'EVENT_CLEANING_EMPLOYEE',
  eventOwner: 'EVENT_OWNER',
};

export const RoleToClaim = {
  [Role.administrator]: 'iadm',
  [Role.operations]: 'operations',
  [Role.humanResources]: 'human_resources',
  [Role.accountManager]: 'account_manager',
  [Role.marketing]: 'marketing',
  [Role.support]: 'support',
  [Role.finance]: 'finance',
  [Role.eventManager]: 'event_manager',
  [Role.eventCleaningEmployee]: 'event_cleaning_employee',
  [Role.eventOwner]: 'event_owner',
};
